import {
  BuyerProductGetResponseChildType,
  BuyerProductGetResponseType,
  StockListResponseType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import { DialogCTA } from "../../../../components/modal/Dialog";
import { SharedButtonContent } from "./SharedButtonContent";

export const DiscoveryProductDialogCta = ({
  source = "market",
  supplier,
  product,
  connection,
}: {
  source?: "market" | "order";
  product:
    | StockListResponseType[number]
    | BuyerProductGetResponseType
    | BuyerProductGetResponseChildType
    | undefined;
  supplier: BuyerProductGetResponseType["Supplier"];
  connection:
    | SupplierStorefrontV2GetResponseType["SupplierRetailerConnection"]
    | null
    | undefined;
}) => {
  if (!product) return null;

  return (
    <DialogCTA>
      <SharedButtonContent
        source={source}
        supplier={supplier}
        product={product}
        connection={connection}
      />
    </DialogCTA>
  );
};
